module.exports = __webpack_public_path__ + "img/laschet-plagiat.5e136d82.png";